"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSetDictateState;

var _useWebChatAPIContext = _interopRequireDefault(require("./useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSetDictateState() {
  return (0, _useWebChatAPIContext.default)().setDictateState;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VTZXREaWN0YXRlU3RhdGUuanMiXSwibmFtZXMiOlsidXNlU2V0RGljdGF0ZVN0YXRlIiwic2V0RGljdGF0ZVN0YXRlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxrQkFBVCxHQUE4QjtBQUMzQyxTQUFPLHFDQUF1QkMsZUFBOUI7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTZXREaWN0YXRlU3RhdGUoKSB7XG4gIHJldHVybiB1c2VXZWJDaGF0QVBJQ29udGV4dCgpLnNldERpY3RhdGVTdGF0ZTtcbn1cbiJdfQ==